import React from "react";
import dynamic from "next/dynamic";
import TextInfo from "@/bit/components/components.text";
import IconGlyph from "@/bit/components/components.icon-glyph";
import Label from "@/bit/components/components.label";
import { getLayoutClassName } from "../utils";
const CmsEditableGroupIcons = dynamic(() => import("@/bit/components/components.cms-block.cms-editable-group-icons"));

function Characteristic(props) {
  const { title, description, icon, label, layout, cmsHandler, alias, blockName, index, frontalListToDelete, className = "" } = props;

  return (
    <div className={`${className} ${getLayoutClassName(layout, "characteristics-item")}`}>
      {/* Bolitas de edicion aqui */}
      <CmsEditableGroupIcons
          noCustomLink
          elementProps={{
          }}
          deleteProps={{
            index,
            itemIdDotNotation: `${blockName}${layout === "default" ? ".cms-ml-characteristics-1" : ""}.cms-ml-single-characteristic-list`,
            alias,
            frontalListToDelete
          }}
          visibleTools={{
            hiring: false,
            edit: false,
            deleteItem: true,
          }}
          cmsHandler={cmsHandler}
        />
      <div className="characteristics-item-icon">
        <IconGlyph {...icon} cmsHandler={cmsHandler} />
      </div>
      <div className="characteristics-item-content">
        <div className="characteristics-item-title">
          <Label {...label} cmsHandler={cmsHandler} />
          <TextInfo {...title} cmsHandler={cmsHandler} />
        </div>
        <div className="characteristics-item-text">
          <TextInfo {...description} cmsHandler={cmsHandler} />
        </div>
      </div>
      <style jsx>{`.characteristics-item {
  position: relative;
  display: flex;
  gap: 0.5rem;
  &-grid {
    flex-flow: column nowrap;
    justify-content: flex-start;
    align-items: center;
    .characteristics-item-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      flex-grow: 1;
    }
    .characteristics-item-title {
      min-height: 3em; 
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  &-default  {
    .characteristics-item-icon {
      width: 30px;
    }
  }
  .characteristics-item-icon {
    min-width:30px;
  }
}

@media screen and (max-width: 768px) {
  .characteristics-item {
    &-grid {
      width: 40%;
    }
  }
}
`}</style>
    </div>
  );
}

export default Characteristic;
